import { render, staticRenderFns } from "./CopyrightSideBar.vue?vue&type=template&id=6cbdb26a&scoped=true&"
import script from "./CopyrightSideBar.vue?vue&type=script&lang=js&"
export * from "./CopyrightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightSideBar.vue?vue&type=style&index=0&id=6cbdb26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbdb26a",
  null
  
)

export default component.exports